import { init, logEvent } from '@amplitude/analytics-browser'
import * as React from 'react'
import { useEffect } from 'react'

interface Props {
  page: string
}

const AmplitudeInit = (props: Props): JSX.Element => {
  useEffect(() => {
    init(
      `${
        process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
          ? 'cfd645850598c50f39af5c90dca515b6'
          : '84e0d2424fea4a96bb8c71846ca3877e'
      }`
    )
    //TODO: Create events for these.
    logEvent(`View ${props.page} Page`)
  }, [])

  return <div></div>
}

export default AmplitudeInit
